<template>
    <div class="popup popup-priceTips" :class="{ 'modal-in': isShow, 'modal-out': !isShow}" id="priceTipsPopup">
        <div class="shorexDetail-title js-returnDetailBtn">
            <p>价格说明</p>
            <a class="shorexDetail-returnButton close-popup" @click="goBack()">
                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png">
            </a>
        </div>
        <div class="ruleDetail">
            <div class="rule-item">
                <div class="rule-item-title"></div>
                <div class="rule-item-text">
                     <p>1.早订特惠价：为鼓励客人尽早计划行程并确认预订而对部分航线或房型特别开放的一种特惠价，是在零售指导价或优惠价的基础上，再享受额外价格优惠的船票价，适用“收费退订”政策。</p>
                    <p>2.优惠价：在零售指导价的基础上，享受了游轮公司品牌特惠和适用的限时闪惠（针对特定年龄或需使用优惠券或活动码等需经验证后方可享受的限时闪惠除外）后的船票价，适用“常规退订”政策。</p>
                    <p>3.零售指导价：即游轮公司根据市场情况制定和建议的船票零售价，并非中国法律法规所定义的“原价”，且可能由游轮公司不时调整，适用“常规退订”政策。</p>
                    <p>4.含税价格：价格标注“（含税）”的，则该价格已包含了在售房型相应的船票价格以及港务税费。</p>
                    <p>5.人均起价：价格标注“/人起”的，则该价格为各个在售房型根据人均计算的起价。人均价格仅为网页显示便利之目的而提供，同舱房每位客人的船票价会因入住人数和适用优惠而有所不同，请以最终订单显示为准。</p>
                    <p>6.以上价格均未包含游轮服务费或其它收费或自费项目，并可能因实时库存变更、网络延迟或缓存等因素造成一定的误差，正式价格请以最终订单显示为准。</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CruisePriceInfo",
    props: {
        onGoBack: {
            type: Function
        },
        isShow: {
            type: Boolean,
            default () {
                return false
            }
        }
    },
    methods:{
        goBack() {
            this.onGoBack()
        }
    }
}
</script>

<style lang="less" scoped>
#priceTipsPopup.popup {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(100%, 0, 0);
    display: block;
}
#priceTipsPopup.modal-in {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(0, 0, 0);
}
#priceTipsPopup.modal-out {
    transform: translate3d(100%, 0, 0);
}

#priceTipsPopup {
    .shorexDetail-title {
        padding: 15px 20px;
        background-color: #fff;
        overflow: hidden;
        text-align: center;
        margin-bottom: 10px;
        position: fixed;
        width: 100%;
        z-index: 10;
        > p {
            
            font-size: 14px;
            color: #333333;
            letter-spacing: 1px;
            text-align: center;
            margin: 0;
        }
        .shorexDetail-returnButton {
            width: 30px;
            position: absolute;
            top: 15px;
            left: 20px;
            text-align: left;
            > img {
                width: 33%;
            }
        }
    }
    .ruleDetail {
        margin-top: 60px;
        height: 100%;
        overflow: scroll;
        padding-bottom: 60px;
        .rule-item {
            margin-bottom: 0px;
            padding: 0 20px 12px;
            font-size: 12px;
            line-height: 20px;
            color: #666;
            letter-spacing: 0;
            background-color: #fff;
            .rule-item-title {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -moz-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                padding: 17px 0 7px;
                font-size: 14px;
                line-height: 20px;
                color: #4A90E2;
                font-weight: bold;
            }
            .rule-item-text p {
                margin: 0px;
            }
        }
    }

}


</style>

